import { useEffect, useState } from "react";
import { _LoanConfigProfile, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import useModal, { MODAL_LG, MODAL_md } from "../../../../../theme/Component/hooks/useModal";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { BasicTable, MASK_BOOLEAN, MASK_NUMBER } from "../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../theme/Component/Modal";
import { toast } from "react-toastify";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { BasicSwitch } from "../../../../../theme/Component/BasicSwitch";

interface Props {
    idLoanConfigProfile: number
}
export const LoanConcept = ({ idLoanConfigProfile }: Props) => {

    const _config = useDataBean(_LoanConfigProfile);
    const { bean, setBean, lista, setLista, handleChange } = _config;

    const modalAdd = useModal("Configuración", MODAL_md);
    const modalDel = useModal("Eliminar", MODAL_md);
    const modalConcept = useModal("Conceptos", MODAL_LG);
    const [concepts, setConcepts] = useState<any>([]);

    useEffect(() => {
        getLoanConceptCatalog();
        _config.instance.getLoanConceptConstants(null).then(
            (resp: any) => {
                setConcepts(resp);

            }
        )
    }, [idLoanConfigProfile])

    const getLoanConceptCatalog = () => {
        _config.instance.getLoanConceptCatalog(idLoanConfigProfile).then(
            (resp: any) => {
                setLista(resp);
            }
        )
    }

    const agregar = () => {
        let temp: any = {};
        if (concepts.length > 0) {
            temp.Type = concepts[0].DataBeanProperties.Value;
        }
        setBean(temp);
        modalAdd.open();
    }
    const addLoanConceptCatalog = () => {

        if (bean.Type && bean.Code && bean.Name) {
            _config.instance.addLoanConceptCatalog(idLoanConfigProfile, bean.Type, bean.Code, bean.Name).then(
                (resp: any) => {
                    getLoanConceptCatalog();
                    modalAdd.close();
                }
            );

        } else {
            toast.warning("Faltan Campos en el Formulario");
        }
    }
    const deleteItem = () => {
        _config.instance.deleteLoanConcept(bean.IDLoanConcept).then(
            (resp: any) => {
                getLoanConceptCatalog();
                modalDel.close();
            }
        )
    }
    const enableForm = () => {
        let b = { ...bean };
        b.ApplyToQuotaForm = true;
        _config.instance.updateLoanConcept(b).then(
            (resp: any) => {
                toast.success("Concepto actualizado");
                getLoanConceptCatalog();
            }
        )
    }
    const disableForm = () => {
        let b = { ...bean };
        b.ApplyToQuotaForm = false;
        _config.instance.updateLoanConcept(b).then(
            (resp: any) => {
                toast.success("Concepto actualizado");
                getLoanConceptCatalog();
            }
        )
    }

    const head = [
        { title: 'ID', property: 'IDLoanConcept', visible: false, mask: MASK_NUMBER },
        { title: 'Codigo', property: 'Type', visible: true },
        { title: 'Tipo', property: 'TypeName', visible: true },
        { title: 'Código Movimiento', property: 'Code', visible: true, mask: MASK_NUMBER },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Habilitar en Formulario de Cuota de Crédito', property: 'ApplyToQuotaForm', visible: true, mask: MASK_BOOLEAN },
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Habilitar en Formulario de Cuota de Crédito', icono: ' ri-checkbox-fill', visible: !bean.ApplyToQuotaForm, evento: () => { enableForm() } },
            { titulo: 'Dehabilitar en Formulario de Cuota de Crédito', icono: ' ri-checkbox-fill', visible: bean.ApplyToQuotaForm === true, evento: () => { disableForm() } },
            { titulo: 'Editar', icono: 'ri-file-add-line', visible: true, evento: () => { modalAdd.open() } },
            { titulo: 'Eliimnar', icono: 'ri-file-add-line', visible: true, evento: () => { modalDel.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: agregar }
    ]

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable head={head} body={lista} rowSet={setBean} iconButtons={iconButtonsItem} listButtons={listaBotones()}></BasicTable>
                <Modal modal={modalAdd.modal} updateModal={modalAdd.setModal} eventModal={addLoanConceptCatalog}>
                    <div className="row">
                        <div className="col-md-12">
                            <label>Tipo</label>
                            <select name="Type" className="form-select" value={bean.Type} onChange={handleChange}>
                                {concepts.map((item: any) => {
                                    return (
                                        <option value={item.DataBeanProperties.Value}>{item.DataBeanProperties.Value} - {item.DataBeanProperties.Property}</option>
                                    )
                                })}
                            </select>
                        </div>
                        <div className="col-md-6">
                            <label>Código</label>
                            <input type="number" className="form-control" name="Code" value={bean.Code} onChange={handleChange} />
                        </div>
                        <div className="col-md-6">
                            <label>Nombre</label>
                            <input type="text" className="form-control" name="Name" value={bean.Name} onChange={handleChange} />
                        </div>
                        {/* <div className="col-md-6">
                                <BasicSwitch  label="Habilitar en Formulario de Cuota de Crédito" estado={bean.ApplyToQuotaForm} eventChange={(e)=>{setBean({...bean,"ApplyToQuotaForm":e})}}/>
                            </div> */}
                        {/* <div className="col-md-12">
                            <PrintJson json={bean} />
                        </div> */}
                    </div>
                </Modal>
                <ModalConfirm modal={modalDel.modal} updateModal={modalDel.setModal} eventModal={deleteItem}>
                    <strong>Eliminar Item?</strong>
                </ModalConfirm>
            </div>
        </div>
    )
}